import React from "react";
import { Container } from "react-bootstrap";
import "../../styles/Contact/CompanyLocationMap.scss";
const CompanyLocationMap = () => {
  return (
    <Container>
      <div className="title">Location</div>
      <div className="google-map">
        {/* Google map integration by using Iframe */}
        <iframe
          width="100%"
          height="500"
          id="gmap_canvas"
          title="google-map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1300.8321776792955!2d90.41264025594822!3d23.809583037722295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c78b0c47699b%3A0x1fbce4eb532a391c!2sTechsist%20Limited!5e0!3m2!1sen!2sbd!4v1640779368044!5m2!1sen!2sbd"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
        ></iframe>
      </div>
    </Container>
  );
};

export default CompanyLocationMap;
